import aa from "search-insights";
import AlgoliaConfig from "controller/algolia/algoliaConfig";
import AlgoliaSendEvent from "controller/algolia/algoliaSendEvent";
import AlgoliaAutocomplete from "controller/algolia/algoliaAutocomplete";

export default class Algolia
{
    constructor(
        appId,
        apiKey,
        index,
        userSessionToken,
        userAccountToken,
        suggestionsIndex,
        trackingEnabled,
        trackingCookieName,
        debounceMS
    ) {
        this.appId = appId,
        this.apiKey = apiKey,
        this.index = index,
        this.userSessionToken = userSessionToken,
        this.userAccountToken = userAccountToken,
        this.suggestionsIndex = suggestionsIndex,
        this.trackingEnabled = trackingEnabled,
        this.trackingCookieName = trackingCookieName,
        this.debounceMS = debounceMS
    }

    setup()
    {
        (new AlgoliaConfig()).init(
            this.appId,
            this.apiKey,
            this.index,
            this.userSessionToken,
            this.userAccountToken,
            this.suggestionsIndex,
            this.trackingEnabled,
            this.trackingCookieName,
            this.debounceMS
        );

        // This needs to be setup on page load as some events are automatically sent by the Algolia widgets.
        aa('init', { appId: this.appId, apiKey: this.apiKey });
        aa('setUserToken', this.userSessionToken);
        aa('setAuthenticatedUserToken', this.userAccountToken ? this.userAccountToken : undefined);

        $(window).on('OFL.productAddedOrRemovedFromCart', function (e, data) {
            if (data.type === 'addToCart') {
                (new AlgoliaSendEvent()).productAddedToCart(data);
            }
        });

        (new AlgoliaAutocomplete()).startAutocomplete();
    }
}